"use client"
import styled from "@emotion/styled"
import { FormControlLabel, Radio, RadioGroup } from "@mui/material"
import { DonationMessages } from "app/[locale]/(layout)/donation-application-form/page"
import { Controller } from "react-hook-form"
import { FormHelperErrorIcon, NewText, RadioCheckedIcon, RadioUnCheckedIcon } from "ui"

const StyledContainer = styled.div`
  margin: 16px 0;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin: 24px 0;
  }
`

const StyledErrorContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 4px;
`

type Props = {
  title: string
  desktopFontSize?: number
  mobileFontSize?: number
  control: any
  name: string
  messages: DonationMessages
  error: boolean
  errorMessage?: string
}

export const NonBinaryRadio: React.FC<Props> = ({
  desktopFontSize = 18,
  mobileFontSize = 16,
  title,
  control,
  name,
  messages,
  error,
  errorMessage,
}) => {
  const errorId = `${name}-error`
  const headingId = `${name}-heading`

  return (
    <StyledContainer>
      <NewText
        id={headingId}
        desktopFontSize={desktopFontSize}
        desktopFontWeight="400"
        desktopLineHeight="100%"
        mobileFontSize={mobileFontSize}
        mobileFontWeight="400"
        mobileLineHeight={"100%"}
        component="h2"
        color={"black"}
        marginBottom="16px"
      >
        {title}
      </NewText>
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          return (
            <RadioGroup
              row={false}
              {...field}
              aria-labelledby={headingId}
              aria-describedby={error && errorMessage ? errorId : undefined}
            >
              <FormControlLabel
                value={"SustainableEnvironment"}
                control={
                  <Radio
                    icon={<RadioUnCheckedIcon error={error} />}
                    checkedIcon={<RadioCheckedIcon />}
                    inputProps={{ "aria-invalid": error || undefined } as React.InputHTMLAttributes<HTMLInputElement>}
                    sx={{
                      "&.Mui-focusVisible": {
                        outline: "2px solid currentColor",
                        outlineOffset: "2px",
                        borderRadius: "50%",
                      },
                    }}
                  />
                }
                label={
                  <NewText
                    desktopFontSize={18}
                    desktopFontWeight="400"
                    desktopLineHeight="100%"
                    mobileFontSize={16}
                    mobileFontWeight="400"
                    mobileLineHeight={"100%"}
                    component="span"
                    color={"black"}
                  >
                    {messages.promotingA}
                  </NewText>
                }
              />
              <FormControlLabel
                value={"PeopleSafety"}
                control={
                  <Radio
                    icon={<RadioUnCheckedIcon error={error} />}
                    checkedIcon={<RadioCheckedIcon />}
                    inputProps={{ "aria-invalid": error || undefined } as React.InputHTMLAttributes<HTMLInputElement>}
                    sx={{
                      "&.Mui-focusVisible": {
                        outline: "2px solid currentColor",
                        outlineOffset: "2px",
                        borderRadius: "50%",
                      },
                    }}
                  />
                }
                label={
                  <NewText
                    desktopFontSize={18}
                    desktopFontWeight="400"
                    desktopLineHeight="100%"
                    mobileFontSize={16}
                    mobileFontWeight="400"
                    mobileLineHeight={"100%"}
                    component="span"
                    color={"black"}
                  >
                    {messages.safetyAndW}
                  </NewText>
                }
              />
              <FormControlLabel
                value={"Communalism"}
                control={
                  <Radio
                    icon={<RadioUnCheckedIcon error={error} />}
                    checkedIcon={<RadioCheckedIcon />}
                    inputProps={{ "aria-invalid": error || undefined } as React.InputHTMLAttributes<HTMLInputElement>}
                    sx={{
                      "&.Mui-focusVisible": {
                        outline: "2px solid currentColor",
                        outlineOffset: "2px",
                        borderRadius: "50%",
                      },
                    }}
                  />
                }
                label={
                  <NewText
                    desktopFontSize={18}
                    desktopFontWeight="400"
                    desktopLineHeight="100%"
                    mobileFontSize={16}
                    mobileFontWeight="400"
                    mobileLineHeight={"100%"}
                    component="span"
                    color={"black"}
                  >
                    {messages.community}
                  </NewText>
                }
              />
              <FormControlLabel
                value={"Other"}
                control={
                  <Radio
                    icon={<RadioUnCheckedIcon error={error} />}
                    checkedIcon={<RadioCheckedIcon />}
                    inputProps={{ "aria-invalid": error || undefined } as React.InputHTMLAttributes<HTMLInputElement>}
                    sx={{
                      "&.Mui-focusVisible": {
                        outline: "2px solid currentColor",
                        outlineOffset: "2px",
                        borderRadius: "50%",
                      },
                    }}
                  />
                }
                label={
                  <NewText
                    desktopFontSize={18}
                    desktopFontWeight="400"
                    desktopLineHeight="100%"
                    mobileFontSize={16}
                    mobileFontWeight="400"
                    mobileLineHeight={"100%"}
                    component="span"
                    color={"black"}
                  >
                    {messages.responding}
                  </NewText>
                }
              />
              <FormControlLabel
                value={"אחר"}
                control={
                  <Radio
                    icon={<RadioUnCheckedIcon error={error} />}
                    checkedIcon={<RadioCheckedIcon />}
                    inputProps={{ "aria-invalid": error || undefined } as React.InputHTMLAttributes<HTMLInputElement>}
                    sx={{
                      "&.Mui-focusVisible": {
                        outline: "2px solid currentColor",
                        outlineOffset: "2px",
                        borderRadius: "50%",
                      },
                    }}
                  />
                }
                label={
                  <NewText
                    desktopFontSize={18}
                    desktopFontWeight="400"
                    desktopLineHeight="100%"
                    mobileFontSize={16}
                    mobileFontWeight="400"
                    mobileLineHeight={"100%"}
                    component="span"
                    color={"black"}
                  >
                    {messages.otherPlea}
                  </NewText>
                }
              />
            </RadioGroup>
          )
        }}
      />
      {error && errorMessage && (
        <StyledErrorContainer id={errorId} role="alert">
          <FormHelperErrorIcon />
          <p
            style={{
              margin: 0,
              textAlign: "right",
              color: "#C92418",
              marginRight: "4px",
              fontSize: "12px",
            }}
          >
            {errorMessage}
          </p>
        </StyledErrorContainer>
      )}
    </StyledContainer>
  )
}
export default NonBinaryRadio
